import Slugify from 'slugify';

function getDefaultConfig() {
  return window.$$REVIEW_CONFIG = window.$$REVIEW_CONFIG || {};
}

let Config = { getConfig: () => null };

Config = {

  setConfig(config) {
    this.config = config;
  },

  getConfig() {
    const defaultConfig = getDefaultConfig();

    const config = Object.assign({}, defaultConfig, this.config || {});

    if (!this.group) {
      return config;
    }

    const groupSlug = Slugify(this.group).toLowerCase();

    const groupSettings = (config.groups || [])
      .find((group) => group.name.toLowerCase() === this.group.toLowerCase() || groupSlug === Slugify(group.name).toLowerCase());

    if (!groupSettings || groupSettings.disabled) {
      return config;
    }

    const settings = Object.assign({}, config);

    if (groupSettings.facebookReviewLink) {
      settings.facebookReviewLink = groupSettings.facebookReviewLink;
    }
    if (groupSettings.googleReviewLink) {
      settings.googleReviewLink = groupSettings.googleReviewLink;
    }

    return settings;
  },

  setGroup(group) {
    this.group = group;
  },

  getFacebookReviewLink() {
    const config = Config.getConfig();
    return config.facebookReviewLink;
  },
  getGoogleReviewLink() {
    const config = Config.getConfig();
    return config.googleReviewLink;
  },
  getReCAPTCHAKey() {
    const config = Config.getConfig();
    return config.reCAPTCHAKey;
  },
  getNegativeFeedbackUrl() {
    const config = Config.getConfig();
    return config.negativeFeedbackUrl;
  },
  getNegativeFeedbackKey() {
    const config = Config.getConfig();
    return config.negativeFeedbackFormKey;
  },
  getHeaderImage() {
    const config = Config.getConfig();
    return config.headerImage;
  },
  getFooterImage() {
    const config = Config.getConfig();
    return config.footerImage;
  },
  getLogo() {
    const config = Config.getConfig();
    return config.logo;
  },
  getLogoMobile() {
    const config = Config.getConfig();
    return config.logoMobile || config.logo;
  },
  getWebsite() {
    const config = Config.getConfig();
    return config.website;
  }
};

export default Config;




// WEBPACK FOOTER //
// ./src/config.js